import { get, post } from "utils/axiosInstance";

const BASE_URL = "/rest/maintenance/provider-portal";

// Dashboard
export const fetchDashboard = () => get(`${BASE_URL}/dashboard/`);

// Profile
export const fetchProfile = () => get(`${BASE_URL}/profile/`);

// Tasks
export const fetchTasks = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append("status", params.status);
  if (params.date_from) queryParams.append("date_from", params.date_from);
  if (params.date_to) queryParams.append("date_to", params.date_to);

  const queryString = queryParams.toString();
  return get(`${BASE_URL}/tasks/${queryString ? `?${queryString}` : ""}`);
};

// Task Detail
export const fetchTaskDetail = (taskId) => get(`${BASE_URL}/tasks/${taskId}/`);

// Start Task
export const startTask = (taskId) => post(`${BASE_URL}/tasks/${taskId}/start/`);

// Complete Task
export const completeTask = (taskId, data) => post(`${BASE_URL}/tasks/${taskId}/complete/`, data);

// Upload Photo
export const uploadTaskPhoto = (taskId, formData) =>
  post(`${BASE_URL}/tasks/${taskId}/upload-photo/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
